module.exports = __webpack_public_path__ + "assets/img/0413.0cffb2db.svg";